// Copyright (C) 2019-2020 Intel Corporation
//
// SPDX-License-Identifier: MIT

module.exports = {
    backendAPI: 'http://localhost:7000/api/v1',
    proxy: false,
};
